import { useMutation } from '@fv/client-core'
import { fvDate } from '@fv/dates'
import type { UpdateBidExpirationDto } from '@fv/models'
import { dates } from '@fv/models/core'

import { shipperFetch } from '@/utils/shipperFetch'

type UpdateDto = {
  loadId: string
  localDateTime?: Date
}

const postBidExpirationDate = async ({ loadId, localDateTime }: UpdateDto) => {
  const date = fvDate(localDateTime)
  const body: UpdateBidExpirationDto = !localDateTime
    ? { local: null, utc: null }
    : {
        local: dates.dateToStringWithLocalTimezoneAbbr(date),
        utc: date.utc().toDate(),
      }
  return await shipperFetch(`/shipments/${loadId}/update-bid-expiration-date`, {
    body,
    method: 'POST',
  })
}

export const useUpdateBidExpirationDate = () => {
  return useMutation(postBidExpirationDate)
}
